export default function (ref) {
    return JSON.parse(JSON.stringify(ref))
}
